import React from "react";
import { Info, AlertTriangle } from "lucide-react";

export function IllustrativeBanner({ className = "" }) {
  return (
    <div className={`flex items-start gap-3 rounded-lg border border-amberbrand/30 bg-amberbrand/5 p-4 ${className}`}
         data-testid="illustrative-banner">
      <Info className="mt-0.5 h-5 w-5 shrink-0 text-amberbrand" />
      <p className="text-sm text-slate-600">
        <span className="font-semibold text-amberbrand">ILLUSTRATIVE ESTIMATE ONLY.</span>{" "}
        Compensation is not guaranteed and depends on the provider's approved written agreement, applicable law,
        a successful qualifying transaction, collected revenue and provider payment terms.
      </p>
    </div>
  );
}

export function ComplianceNotice({ className = "" }) {
  return (
    <div className={`flex items-start gap-3 rounded-lg border border-amberbrand/40 bg-amberbrand/10 p-4 ${className}`}
         data-testid="compliance-notice">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amberbrand" />
      <p className="text-sm font-medium text-slate-700">
        DO NOT ENTER MEDICAL RECORDS, DIAGNOSES, SSNs, MEDICAID IDs, MEDICARE IDs, INSURANCE IDs OR UNNECESSARY
        PROTECTED HEALTH INFORMATION. Collect only what is reasonably necessary for business-development routing.
      </p>
    </div>
  );
}
